import { reaction } from "mobx";

/** What the listener was trying to do when sign-in came in the way, and what to do once they are in */
export interface SignInIntent {
    /** Said in the dialog, e.g. "Logga in för att följa Podd" */
    message: string;
    /** Carries it out as the signed-in listener; true when it worked */
    resume?: () => Promise<boolean>;
    /** Told to the listener when `resume` worked */
    doneMessage?: string;
}

interface ResumeDeps {
    isSignedIn: () => boolean;
    /** Resolves when the account's data is in place, so the action is not undone by a reload */
    ready: () => Promise<void>;
    /** Takes the pending intent, if any, so it only runs once */
    take: () => SignInIntent | null;
    notify: (message: string) => void;
}

/** Runs the pending intent when the listener has signed in. Returns the way to stop. */
export const resumeAfterSignIn = ({ isSignedIn, ready, take, notify }: ResumeDeps) =>
    reaction(isSignedIn, async (signedIn) => {
        if (!signedIn) return;
        await ready();
        const intent = take();
        if (!intent?.resume) return;
        try {
            if ((await intent.resume()) && intent.doneMessage) notify(intent.doneMessage);
        } catch (error) {
            console.warn("Could not finish what the listener started before signing in", error);
        }
    });
